module.exports = __webpack_public_path__ + "img/AmLogoNewWhiteStrokeAug13Wy 1.75b6a482.png";